import React from "react";
import { FormattedMessage } from "react-intl";
import { PauseOutlined, CaretRightOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Image } from "./types";

export const UTM =
  "?utm_source=Start&utm_medium=referral&utm_campaign=api-credit";

interface Props {
  credit: Image["credit"];
  paused: boolean;
  onPause: () => void;
  onPrev: (() => void) | null;
  onNext: (() => void) | null;
  hideInfo: boolean;
  hideControls: boolean;
}

const UnsplashCredit: React.FC<Props> = ({
  credit,
  paused,
  onPause,
  onPrev,
  onNext,
  hideInfo,
  hideControls,
}) => (
  <div className="credit">
    {hideInfo ? null : <div className="photo" style={{ fontSize: '10px', marginBottom: '-12px', opacity: 0.6 }}>
      <a href={credit.imageLink + UTM} rel="noopener noreferrer">
        <FormattedMessage
          id="plugins.unsplash.photoLink"
          description="Photo link text"
          defaultMessage="Photo"
        />
      </a>
      {", "}
      <a href={credit.userLink + UTM} rel="noopener noreferrer">
        {credit.userName}
      </a>
      {", "}
      <a href={"https://unsplash.com/" + UTM} rel="noopener noreferrer">
        Unsplash
      </a>
      {credit.location ? `, ${credit.location}` : ''}
    </div>}

    {hideControls ? null : <div className="controls">
      <a style={{ visibility: onPrev ? "visible" : "hidden" }} onClick={onPrev ?? undefined}>
        <LeftOutlined />
      </a>{" "}
      <a onClick={onPause}>
        {paused ? <PauseOutlined /> : <CaretRightOutlined />}
      </a>{" "}
      <a style={{ visibility: onNext ? "visible" : "hidden" }} onClick={onNext ?? undefined}>
        <RightOutlined />
      </a>
    </div>}
  </div>
);

export default React.memo(UnsplashCredit);
